import { ArrowUpRight } from "lucide-react";
import { Reveal, scrollToId } from "./motion";

// Photographic product grid (used by the Solar Hot Water page)
export const PhotoProducts = ({ overline, title, subtitle, products }) => {
  return (
    <section id="products" data-testid="product-showcase" className="relative py-28 lg:py-40 bg-[#010101]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div>
            <Reveal><p className="text-xs tracking-[0.3em] uppercase text-[#fcc41b] font-display font-medium mb-5">{overline}</p></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display font-semibold tracking-tighter leading-[0.95] text-white" style={{ fontSize: "clamp(2.25rem, 5.5vw, 4.5rem)" }}>
                {title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}><p className="text-zinc-400 max-w-sm text-base leading-relaxed">{subtitle}</p></Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {products.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08} className={p.span}>
              <button
                data-testid={`product-card-${p.id}`}
                onClick={() => scrollToId("quote")}
                className="group relative w-full text-left rounded-3xl overflow-hidden border border-[#262626] bg-[#0d0d0d] hover:border-[#fcc41b]/40 transition-colors duration-500 h-full min-h-[420px] flex flex-col"
              >
                <div className="relative h-64 lg:h-72 overflow-hidden">
                  <img src={p.image} alt={p.name} className="grayscale-img w-full h-full object-cover group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d] via-transparent to-transparent" />
                  <span className="absolute top-5 left-5 font-mono-eng text-[10px] tracking-wider uppercase text-black bg-[#fcc41b] rounded-full px-3 py-1">{p.sub}</span>
                </div>
                <div className="p-8 flex flex-col gap-5 flex-1">
                  <div className="flex flex-wrap gap-2">
                    <span className="font-mono-eng text-[10px] tracking-wider text-zinc-400 border border-[#262626] rounded-full px-3 py-1.5">{p.flow}</span>
                    <span className="font-mono-eng text-[10px] tracking-wider text-zinc-400 border border-[#262626] rounded-full px-3 py-1.5">{p.power}</span>
                  </div>
                  <h3 className="font-display font-semibold text-2xl text-white leading-tight">{p.name}</h3>
                  <p className="text-zinc-400 leading-relaxed">{p.tagline}</p>
                  <div className="mt-auto flex items-center gap-2 text-[#fcc41b] font-display font-medium text-sm">
                    Request Quote
                    <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
                  </div>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
